import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { LanguageProvider, useLang } from '../contexts/LanguageContext';
import { PlatformSection } from '../components/landing/PlatformSection';
import { Footer } from '../components/landing/Footer';

// BBMI-OAI lives on its own page: it proves Kaizen Kanri's build capability
// but pulls warehouse visitors into a different market if left on the
// Kanriva homepage.
const BbmiBody = () => {
  const { lang } = useLang();
  const back = lang === 'nl' ? 'Terug naar Kanriva\u2122' : 'Back to Kanriva\u2122';
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <header className="border-b border-white/10 bg-[#0a0a0a]/80 backdrop-blur-xl sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3" data-testid="bbmi-home-link">
            <img src="/brand/kanriva-logo.png" alt="Kanriva" className="h-8 w-auto" />
          </Link>
          <Button asChild variant="ghost" className="text-white/60 hover:text-white" data-testid="bbmi-back">
            <Link to="/"><ArrowLeft className="h-4 w-4 mr-2" /> {back}</Link>
          </Button>
        </div>
      </header>
      <PlatformSection only="bbmi" />
      <Footer />
    </div>
  );
};

export default function BbmiPage() {
  return (
    <LanguageProvider>
      <BbmiBody />
    </LanguageProvider>
  );
}
